import { render, staticRenderFns } from "./InvoiceTaskCard.vue?vue&type=template&id=22bcd418&scoped=true&"
import script from "./InvoiceTaskCard.vue?vue&type=script&lang=js&"
export * from "./InvoiceTaskCard.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceTaskCard.vue?vue&type=style&index=0&id=22bcd418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bcd418",
  null
  
)

export default component.exports